/*
 * Copyright (c) 2021. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';
import { ProgressBarViewModel } from 'src/types/view-models/progress-bar.view.model';

import styles from './ProgressBar.module.scss';
import ProgressService from '../../services/progress.service';

export interface ProgressBarState {
    barWidth: string;
}

export default class ProgressBar extends Component<ProgressBarViewModel, ProgressBarState> {
    public override state = {
        barWidth: `${this.props.min}%`
    };

    public override componentDidMount(): void {
        setTimeout(
            () => this.setState({ barWidth: ProgressService.getBarWidth(this.props) }),
            this.props.animationDelay
        );
    }

    public override render(): ReactComponentElement<any> {
        const containerStyle: { width: string | number; height?: string | number } = {
            width: this.props.width
        };
        if (this.props.height) containerStyle.height = this.props.height;

        const barStyle: { width: string; transitionDuration: string; borderRadius?: string; background?: string } = {
            width: this.state.barWidth,
            transitionDuration: this.props.animationSpeed
        };
        if (this.props.borderRadius) barStyle.borderRadius = `${this.props.borderRadius}px`;
        if (this.props.barColour) barStyle.background = this.props.barColour;

        const backgroundStyle: { background?: string; borderRadius?: string } = {};
        if (this.props.backgroundColour) backgroundStyle.background = this.props.backgroundColour;
        if (this.props.borderRadius) backgroundStyle.borderRadius = `${this.props.borderRadius}px`;

        return (
            <div className={styles.progressBarContainer} style={containerStyle}>
                <div className={styles.progressBackground} style={backgroundStyle}>
                    <div className={styles.progressBar} style={barStyle} />
                </div>
            </div>
        );
    }
}
